module.exports = __webpack_public_path__ + "ck.svg?e697f1d6abb7428144013869667caa87";